import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const seoWrapperTestId = "cdp-seo-wrapper";
export const SeoH1Wrapper = ({ children }) => {
    return (_jsx(Box, { as: "h1", marginVertical: 0, paddingHorizontal: {
            "breakpoint.base": "spacing.16",
            "breakpoint.sm": "spacing.32",
            "breakpoint.lg": "0",
        }, testId: seoWrapperTestId, children: children }));
};
